import { render, staticRenderFns } from "./personalAuthentication.vue?vue&type=template&id=64bc8567&scoped=true&"
import script from "./personalAuthentication.vue?vue&type=script&lang=js&"
export * from "./personalAuthentication.vue?vue&type=script&lang=js&"
import style0 from "./personalAuthentication.vue?vue&type=style&index=0&id=64bc8567&prod&lang=less&"
import style1 from "./personalAuthentication.vue?vue&type=style&index=1&id=64bc8567&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64bc8567",
  null
  
)

export default component.exports